<template>
  <div class="smartcard">
    <div class="toolbar text-right">
      <label v-if="smartcard.AccountUuid" class="label label-success">
        Assigned
      </label>
      <label v-if="!smartcard.AccountUuid" class="label label-danger">
        Unassigned
      </label>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <h4>Smart Card</h4>
        <p><strong>Chip ID:</strong> {{ smartcard.chipId }}</p>
        <p><strong>Card Number:</strong> {{ smartcard.cardNumber }}</p>
        <p><strong>Note:</strong> {{ smartcard.note }}</p>
        <p v-if="smartcard.Account"><strong>Assigned to:</strong>
          <router-link :to="{ path: '/membership/members/' +  smartcard.AccountUuid}">
            {{ smartcard.Account.dropdownLabel }}
          </router-link>
        </p>
      </div>
    </div>
    <div class="toolbar text-right">
      <button class="btn btn-default" @click="unassignCardModal()" v-if="smartcard.AccountUuid && isFinanceAdmin">
        <span class="fa fa-times fa-fw"></span> Unassign
      </button>
    </div>
    <!-- confirmation modal -->
    <modal ref="confirmationModal" v-if="modalActive">
      <template slot="header">
        <h4 class="modal-title">Confirm Unassign Smartcard</h4>
      </template>
      <template slot="body">
        Click accept to unassign card with chip ID
        <strong>{{ smartcard.chipId }}</strong> and number
        <strong>{{ smartcard.cardNumber || 'no number' }}</strong>
        from <strong>{{ smartcard.Account.dropdownLabel }}</strong>. The card
        will also be available to reassign to a new member.
      </template>
      <template slot="footer">
        <button class="btn btn-default pull-left" data-dismiss="modal"
        type="button">Cancel</button>
        <button @click="unassignCard()" class="btn btn-success"
        type="button">Accept</button>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from '../Modal'
export default {
  name: 'Smartcard',
  props: {
    object: {
      type: Object
    },
    isFinanceAdmin: {
      type: Boolean
    }
  },
  components: {
    Modal
  },
  data () {
    return {
      smartcard: {},
      modalActive: false
    }
  },
  mounted () {
    this.smartcard = this.object
  },
  methods: {
    unassignCardModal () {
      this.modalActive = true
      this.$nextTick(function () {
        $(this.$refs.confirmationModal).modal()
        $(this.$refs.confirmationModal).on('hidden.bs.modal', (e) => {
          this.modalActive = false
        })
      })
    },
    unassignCard () {
      let smartcardUuid = this.smartcard.uuid
      this.$http.post('admin/object/unassignSmartcard', { smartcardUuid }).then(({data}, status, request) => {
        $(this.$refs.confirmationModal).modal('hide')
        this.$parent.search()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/Smartcard.vue